import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Box, CircularProgress } from "@mui/material";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    // Optionally show a spinner or nothing while checking auth
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
        <CircularProgress />
      </Box>);
  }

  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  return children;
}
